import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const navigate = useNavigate();

  // Notifications are in-app only, so there is nothing pushing them to the
  // browser — a gentle poll is what keeps the badge honest while someone leaves
  // the portal open. It is a single indexed count, and `retry: false` keeps a
  // blip from stacking up requests behind a failing one.
  const { data } = useQuery({
    queryKey: ["unreadNotifications"],
    queryFn: async () => (await api.get("/my/notifications/unread-count")).data,
    refetchInterval: 60000,
    retry: false,
  });

  const count = data?.count || 0;

  return (
    <button
      onClick={() => navigate("/notifications")}
      className="relative text-navy hover:text-teal transition-colors"
      aria-label={count > 0 ? `Notifications, ${count} unread` : "Notifications"}
      data-testid="notification-bell"
    >
      <Bell className="h-5 w-5" />
      {count > 0 && (
        <span
          className="absolute -top-1.5 -right-1.5 min-w-[17px] h-[17px] px-1 rounded-full bg-red-500
                     text-white text-[10px] font-semibold grid place-items-center"
          data-testid="notification-badge"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
